import { IItem } from "./items";
import {
  IDocumentAlert,
  instanceOfIDocumentAlert,
} from "./IDocumentAlert";
import {
  IDocumentItemSpecifiable,
  instanceOfIDocumentItemSpecifiable,
} from "./IDocumentItemSpecifiable";

export interface IDocumentItemAlert extends IDocumentAlert, IDocumentItemSpecifiable {
  detectedItem: IItem;
}

export function instanceOfIDocumentItemAlert(instance: any): instance is IDocumentItemAlert {
  return (instance.detectedItem !== undefined)
      && instanceOfIDocumentAlert(instance)
      && instanceOfIDocumentItemSpecifiable(instance);
}
